import { useLayoutEffect, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTopOnNavigate = () => {
  const location = useLocation();

  // Prevent browser from auto-restoring scroll position
  useEffect(() => {
    if ('scrollRestoration' in history) {
      const prev = (history as any).scrollRestoration;
      try {
        (history as any).scrollRestoration = 'manual';
      } catch { }
      return () => {
        try {
          (history as any).scrollRestoration = prev || 'auto';
        } catch { }
      };
    }
  }, []);

  // Synchronous scroll reset before paint
  useLayoutEffect(() => {
    const scrollToTopHard = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
    };

    if (location.hash) {
      // Handle hash navigation
      const scrollToHash = () => {
        // Ignore Supabase auth hashes or invalid selectors
        if (location.hash.includes('=') || !location.hash.match(/^#[a-zA-Z][\w-]*$/)) {
          return false;
        }

        try {
          const el = document.querySelector(location.hash);
          if (el instanceof HTMLElement) {
            el.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return true;
          }
        } catch (e) {
          // Ignore invalid selector errors
          console.warn('Invalid hash selector:', location.hash);
        }
        return false;
      };

      if (!scrollToHash()) {
        requestAnimationFrame(() => {
          if (!scrollToHash()) {
            setTimeout(scrollToHash, 50);
          }
        });
      }
    } else {
      // Force scroll to top
      scrollToTopHard();
      // Post-paint fallback for late layout shifts
      requestAnimationFrame(() => {
        scrollToTopHard();
      });
    }
  }, [location.pathname, location.hash]);

  return null;
};

